import React from 'react';

import Slider from 'pages/Settings/LocalMarketSettings/MarketMap/SliderV2';
import Button from '@lotlinx-aws/sparky-component-library/Sparky/Button';
import Flex from '@lotlinx-aws/sparky-component-library/Sparky/Flex';
import NumberInput from '@lotlinx-aws/sparky-component-library/Sparky/NumberInput';
import Text from '@lotlinx-aws/sparky-component-library/Sparky/Text';

import styles from './SliderPopover.module.scss';

interface SliderPopoverProps {
  sliderValue: number[];
  setSliderValue: (val: number[]) => void;
  previousSliderValue: number[];
  sliderHandler: () => void;
}

const SliderPopover: React.FC<SliderPopoverProps> = ({
  sliderValue,
  setSliderValue,
  previousSliderValue,
  sliderHandler,
}) => (
  <div className={styles.sliderPopover}>
    <Text color='secondary' type='label-01'>
      Quick selection tool
    </Text>
    <Text color='secondary' type='body-compact-01'>
      Adjust the slider to bulk select cells by range
    </Text>
    <div className={styles.sliderRow}>
      <Flex column>
        <NumberInput
          id='radius-input'
          suffix=' mi'
          className={styles.textInput}
          value={sliderValue[0]}
          onValueChange={(val) => {
            if (!val.value) {
              return;
            }
            if (Number(val.value) > 14 && Number(val.value) < 251) {
              setSliderValue([Number(val.value)]);
            }
          }}
          min={15}
          max={250}
          step={1}
          showNumberCaret
        />
      </Flex>
      <div className={styles.sliderContainer}>
        <Text type='helper-text-01' color='tertiary'>
          15 mi
        </Text>
        <div className={styles.slider}>
          <Slider value={sliderValue} setValue={setSliderValue} min={15} max={250} />
        </div>
        <Text type='helper-text-01' color='tertiary'>
          250 mi
        </Text>
      </div>
    </div>
    <Button
      onClick={sliderHandler}
      variant='outline'
      className={styles.selectButton}
      disabled={previousSliderValue === sliderValue}
    >
      Select cells in range
    </Button>
  </div>
);

export default SliderPopover;
